<template>
  <div class="container">
	  <div style="position:fixed;right:20px;top:20px;"><el-button @click="btnIndex">申请入驻京体通</el-button></div>
    <section>
      <img src="../../../static/img/官网-V1_03.png?x-oss-process=style/w720" />
    </section>
    <section>
      <img src="../../../static/img/官网-V1_07.png?x-oss-process=style/w720" />
    </section>
    <section>
      <img src="../../../static/img/官网-V1_09.png?x-oss-process=style/w720" />
    </section>
    <section>
      <img src="../../../static/img/官网-V1_10.png?x-oss-process=style/w720" />
    </section>
    <section>
      <img src="../../../static/img/官网-V1_11.png?x-oss-process=style/w720" />
    </section>
    <footer>
      <p>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备2021026144号-1</a></p>
    </footer>
  </div>
</template>

<script>
export default {
  name: '',
  methods: {
  	btnIndex() {
  		this.$router.push('/home')
  	}
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #f1f1f1;
}
.container {
  width: 100%;
  margin: 0 auto;
}

section {
  margin: 0;
  padding: 0;
  display: flex;
}

section img {
  width: 100%;
  display: inline-block;
}

footer {
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  background-color: #333;
  padding: 10px 0;
  text-align: center;
}

footer a {
  color: white;
  text-decoration: none;
}

footer a:hover {
  color: #fcc700;
}
</style>
